import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgTimeout(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      d: "M54.134 28.172C53.148 15.21 42.318 5 29.104 5 15.238 5 4 16.24 4 30.103 4 43.644 14.721 54.681 28.138 55.19",
      stroke: "#7373FF",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0), _jsx("circle", {
      cx: 46.483,
      cy: 47.483,
      r: 13.517,
      stroke: "#FF6652",
      strokeWidth: 2.5
    }, void 0), _jsx("path", {
      d: "M31.086 14.655a1.5 1.5 0 00-3 0h3zm-1.5 17.38v1.5a1.5 1.5 0 001.5-1.5h-1.5zM18 30.535a1.5 1.5 0 000 3v-3zm10.086-15.88v17.38h3v-17.38h-3zm1.5 15.88H18v3h11.586v-3z",
      fill: "#7373FF"
    }, void 0), _jsx("path", {
      d: "M46.5 41v8",
      stroke: "#FF6652",
      strokeWidth: 2.6,
      strokeLinecap: "round"
    }, void 0), _jsx("circle", {
      cx: 46.5,
      cy: 53.5,
      r: 1.5,
      fill: "#FF6652"
    }, void 0)]
  }), void 0);
}

export default SvgTimeout;